import { CheckNotes, InspectionCase } from './inspection-case.dto';

export class InspectionZCoefficientCaseDto extends InspectionCase {
  value?: number = 0;
}
export class InspectionZCoefficientCase extends InspectionZCoefficientCaseDto {
  constructor(data: InspectionZCoefficientCaseDto = {}) {
    super(data);
    this.value = data.value;
  }

  getNotes?(): CheckNotes[] {
    const notes = super.getNotes();

    // if (notes[0]) {
    //   notes[0].notes = notes[0]?.notes?.replace('0', `${this.value}`);
    // }

    return notes;
  }
}
